import {useCallback, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

import {
  requestControllersForScope,
  requestScope,
  storeControllersForScope,
} from "../redux/Actions/general.actions";
import {getControllersForScope, getScope} from "../redux/Selectors/general.selectors";

export const useScopeAndAppliances = () => {
  const dispatch = useDispatch();

  const scopeOptions = useSelector(getScope);
  const applianceOptions = useSelector(getControllersForScope);

  const fetchScope = useCallback(
    (callback) => {
      dispatch(requestScope(callback));
    },
    [dispatch]
  );

  const fetchAppliances = useCallback(
    (scope, callback) => {
      dispatch(
        requestControllersForScope(
          {
            scope,
          },
          callback
        )
      );
    },
    [dispatch]
  );

  // Appliance options are shared via the store, so clear them on unmount
  // to keep them from leaking into other forms that use this data.
  useEffect(() => {
    return () => {
      dispatch(storeControllersForScope([]));
    };
  }, [dispatch]);

  return {
    scopeOptions,
    applianceOptions,
    fetchScope,
    fetchAppliances,
  };
};
